<template>
  <div class="overview-capital">
    <!-- <el-tabs v-model="activeName">
      <el-tab-pane label="申万行业高频模拟和预测库" name="5">
        <p>
          <strong>腾景AI经济预测</strong>运用近年来快速发展的机器学习特别是深度学习等人工智能前沿技术，与实时化、动态化的投入产出体系深度融合，在一系列关键技术攻关的基础上，对重要的经济金融指标进行高频模拟和预测，形成了在国内外具有开拓性、领先性、实用性的产品体系。
        </p>
        <p>
          <strong>是什么</strong>
        </p>
        <p>
          <strong>申万行业分类</strong>是国内较早且广泛采用的行业分类方法，2021版最新分类包含31个一级行业、134个二级行业。
        </p>
        <p>
          <strong>申万行业高频模拟和预测库</strong>运用先进的深度学习算法，搜集整理多渠道的数据来源，
          参照最新申万行业分类标准，对上市公司为主体的一二级行业的营业收入、净利润等重要财务指标进行了日度高频模拟和月度趋势预测，为宏观和行业管理、实体企业经营、资本市场投资与相关科学研究等机构和人士准确判断形势、正确决策提供有效支持。
        </p>
        <p>
          所谓
          <strong>高频模拟，</strong>就是在搜集加工大量相关数据的基础上，依托经典机器学习和深度学习模型，把季度指标月度化、月度指标日度化，使通常几个月后才公布的指标，当日或近日就能呈现出来，比如，
          <strong>行业和上市公司的财务数据，过去要等季报年报公布，有了高频模拟，行业最新情况当日就知晓了。</strong>
        </p>
        <p>
          所谓
          <strong>预测</strong>就是运用深度学习的前沿算法，重点在海量数据中搜寻线性尤其是非线性相关关系，发现并提炼那些过去、当下和未来都会起作用的规律性因素，从而实现对某一指标未来一定时期走势的预测。资本市场走势很大程度上是行业内上市公司经营情况的反映，反过来又对行业发展有重要影响。
          <strong>有效的预测有助于各行业生产经营者、投资者精准捕捉潜能、规避风险、平抑波动，促进各行业稳定而有活力的高质量发展。</strong>
        </p>
        <p>
          有些业内人士认为，
          <strong>这项人工智能与实体经济深度融合的成果，方法高大上，产品接地气、很管用，不仅对市场上的投资者，更重要是对各行业实体经济中的广大上市公司和非上市企业，都能带来实实在在的好处。-12个月）的走势。正所谓近看当日，远观全年，腾景预测，一目了然。</strong>
        </p>
        <p>
          <strong>为什么</strong>
        </p>
        <p>
          <strong>特点</strong>
        </p>
        <p>
          <strong>看得远：</strong>提前一年左右基本把握住重要指标走势和大的拐点。
        </p>
        <p>
          <strong>频率高：</strong>日度监测、月度预测，从跟随报表到领先报表，实时把握并前瞻性预判行业变动。
        </p>
        <p>
          <strong>覆盖广：</strong>预测范围覆盖31个申万一级行业和134个二级行业的营业收入、净利润同比增速等重要财务指标。
        </p>
        <p>
          <strong>迭代快：</strong>：跟踪人工智能技术演变路线，迭代升级算法模型，同时加快扩大数据来源，增加有效数据，提升特征工程水准。
        </p>
        <p>
          <strong>方向准：</strong>指标预测方向准确率通常达到70%以上，并持续改进。
        </p>

        <p>
          <strong>数据库预览</strong>
        </p>
        <p>一级行业31个，可通过“分析”和“速览”模式查看一级行业重要财务指标的日度高频模拟监测和月度趋势预测结果。</p>
        <p class="img">
          <img src="../../assets/img/10.png" alt />
          <img src="../../assets/img/11.png" alt />
        </p>
        <p>二级行业134个，可通过“分析”和“速览”模式查看二级行业重要财务指标的日度高频模拟监测和月度趋势预测结果。</p>
        <p class="img">
          <img src="../../assets/img/12.png" alt />
          <img src="../../assets/img/13.png" alt />
        </p>
        <p>
          <strong>对谁有用</strong>
        </p>
        <p>
          <strong>关注中国宏观和行业经济走势的机构和人士都将从中受益，</strong>重点包括：
          <strong>
            宏观经济和行业发展管理机构、科研机构；
            关注行业增长现状与前景的各行业上市公司和非上市企业
            在波动大、不确定性强的各类市场环境中寻求确定性的机构和个人投资者
          </strong>
        </p>
        <p>
          <strong>申万行业高频模拟和预测库是各行业每一个有远见、重实效、追求高质量发展的生产经营者、投资者和管理者的“标配产品”</strong>
        </p>
      </el-tab-pane>
    </el-tabs> -->
    <div>
      <p>请联系我们：</p>
      <p style="font-size: 14px;">电话:15210925572</p>
      <p style="font-size: 14px;">邮箱:TengjingAI@tjresearch.com</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: "5"
    };
  },
  created() {
    // if (this.$route.query.id) {
    //   this.activeName = this.$route.query.id;
    // }
  }
};
</script>

<style lang="scss" scoped>
.overview-capital {
  background: #fff;
  margin: 20px 0 0 20px;
  padding: 20px;
  box-sizing: border-box;
  .title {
    color: #333399;
    text-align: center;
    font-size: 24px;
    padding: 30px 0;
    .big-title {
      font-size: 28px;
      font-weight: bold;
      margin-bottom: 2px;
    }
  }
  p {
    text-indent: 32px;
    img {
      height: 300px;
      padding-bottom: 20px;
    }
    &.img {
      text-align: center;
    }
  }
  /deep/ .el-tabs .el-tabs__item {
    padding-left: 0 !important;
    padding-bottom: 14px !important;
    height: 42px !important;
    font-size: 16px !important;
  }
}
</style>